<template>
    <div>
        <div class="second-header-wrap">
            <el-select size="medium" @change="noticeChangeHandler()" v-model="currentNotice" placeholder="请选择公告">
                <el-option
                    v-for="item in noticeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-button size="medium" @click="addWindow" type="primary">新增窗口</el-button>
            <el-button size="medium" @click="saveHandler" type="primary">保存</el-button>
            <el-button size="medium" @click="copyLastYear" type="primary">复制上一年设置</el-button>
            <el-button size="medium" @click="isShowPreview = true" type="primary">取号页面预览</el-button>
        </div>
        <div class="main-container">
            <div class="window-section">
                <div>
                    <el-form :model="formData" ref="formData" :rules="formDataRule" label-width="80px">
                        <el-form-item label="取号时间" prop="time">
                            <el-date-picker
                                style="width: 185px;"
                                type="datetime"
                                v-model="formData.openTime"
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                placeholder="选择日期时间">
                            </el-date-picker>
                            至
                            <el-date-picker
                                style="width: 185px;"
                                type="datetime"
                                v-model="formData.closeTime"
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="说明1">
                            <el-input v-model="formData.remarkOne" :maxlength="50" style="width: 392px"/>
                        </el-form-item>
                        <el-form-item label="说明2">
                            <el-input v-model="formData.remarkTwo" :maxlength="50" style="width: 392px"/>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="window-list" v-if="windowSetting.length !== 0">
                    <div class="window-item" :key="windowIndex" v-for="(windowItem, windowIndex) in windowSetting">
                        <div class="window-item__name">
                            <span><span class="require-hint">*</span>窗口名称：</span>
                            <el-input style="width: 60%;" v-model.trim="windowItem.windowNo" :maxlength="20"></el-input>
                        </div>
                        <div class="window-item__fast">
                            <el-checkbox v-model="windowItem.isFast" @change="fastWindowChange(windowIndex)">快速窗口
                            </el-checkbox>
                            <el-checkbox v-model="windowItem.isDependent" @change="dependentWindowChange(windowIndex)">非独立产权
                            </el-checkbox>
                        </div>
                        <div class="window-item__del-btn">
                            <i class="fa fa-close" @click="deleteWindow(windowItem.id, windowIndex)"></i>
                        </div>
                        <div class="address-book-container">
                            <address-book v-model="addressBookData[windowIndex]" :config="addressConfig"></address-book>
                        </div>
                    </div>

                </div>
                <div v-else class="default-page-container">
                    <default-page mes="暂无窗口"></default-page>
                </div>
            </div>
            <div class="qrcode-section">
                <div class="header">
                    <span class="color-block"></span>
                    取号二维码
                </div>
                <div>

                </div>
                <div class="qrcode-container">
                    <img :src="qrcodeUrl"/>
                </div>
                <div class="qrcode-date" v-if="formData.openTime && formData.closeTime">取号 {{formData.openTime | dateFilter}} 至 {{formData.closeTime | monthFilter}}</div>
            </div>
        </div>
        <div class="preview-dialog" v-show="isShowPreview" @click="isShowPreview = false">
            <div class="preview-container" @click.stop>
                <div class="login-form">
                    <div>
                        <div class="ticket-header">
                            <div class="ticket-header__main">恭喜您取号成功</div>
                            <div class="ticket-header__sub">
                                {{formData.remarkOne}}
                            </div>
                        </div>
                        <div class="ticket-detail">
                            <div class="ticket-detail__number">XX窗口XX号</div>
                            <div class="ticket-detail__children">
                                <div>xxxx<span class="small">(报名序号：xxxx)</span>
                                </div>
                            </div>
                            <div style="" class="hint2">{{formData.remarkTwo}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin';
    import {
        getSchoolEnrolNoticeList,
        getNoticeWindowInfo,
        saveNoticeWindowInfo,
        deleteWindowNoById,
        copyBeforeWindowSetInfo
    } from '@/api/primary/setting.js';
    import AddressBook from '@/components/AddressBook/indexExpand';
    import DefaultPage from '@/components/DefaultPage';
    import QRCode from 'qrcode'
    import moment from 'moment';

    export default {
        name: "TicketWindowSetting",
        data: function () {

            const timeValidator = (rule, value, callback) => {
                if(!this.formData.openTime || !this.formData.closeTime) {
                    callback(new Error('取号时间不能为空！'));
                } else if(moment(this.formData.openTime).format('YYYY-MM-DD HH:mm') >= moment(this.formData.closeTime).format('YYYY-MM-DD HH:mm')) {
                    callback(new Error('开始时间必须小于结束时间'));
                } else {
                    callback();
                }
            };
            return {
                windowSetting: [],
                usedIndex: 0,
                noticeList: [],
                currentNotice: '',
                qrcodeUrl: '',
                addressConfig: {
                    title: '请选择审核人',
                    depart: {target: 'user', departType: 't', userTypes: '1'},
                    group: false
                },
                addressBookData: [],
                formData: {
                    openTime: '',
                    closeTime: '',
                    remarkOne: '',
                    remarkTwo: ''
                },
                formDataRule:  {
                    time: [{
                        required: true, validator: timeValidator
                    }],
                },
                isShowPreview: false
            }
        },
        mixins: [baseMixin],
        components: {
            DefaultPage,
            AddressBook
        },
        created() {
            getSchoolEnrolNoticeList({
                searchVal: '',
                state: 2
            })
                .then(res => res.data)
                .then(data => {
                    this.noticeList = data.data;
                    if (data.data.length !== 0) {
                        this.currentNotice = data.data[0].id;
                        this.getNoticeWindowInfoFunc();
                    }
                })
        },
        filters: {
            timeFilter(value) {
                return value.substring(0, value.lastIndexOf(':'));
            },
            dateFilter(value) {
                return value.substring(0, value.lastIndexOf(' '));
            },
            monthFilter(value) {
                return value.substring(value.indexOf('-') + 1, value.lastIndexOf(' '));
            }
        },
        methods: {
            noticeChangeHandler() {
                setTimeout(() => {
                    this.getNoticeWindowInfoFunc();
                }, 100);
            },
            getNoticeWindowInfoFunc() {
                getNoticeWindowInfo({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        pageData.windowNoList.forEach(item => {
                            item.isDependent = item.isFast === 3
                            item.isFast = item.isFast === 1;
                        });
                        this.windowSetting = pageData.windowNoList;
                        this.addressBookData = pageData.windowNoList.map(({examineUserList}) => ({
                            departJson: [],
                            groupJson: [],
                            userJson: examineUserList
                        }));
                        this.formData = {
                            openTime: pageData.openTime,
                            closeTime: pageData.closeTime,
                            remarkOne: pageData.remarkOne || '',
                            remarkTwo: pageData.remarkTwo || '',

                        };
                        this.generateQrcode();
                    })
            },
            generateQrcode() {
                const schoolId = this.noticeList.find(({id}) => id === this.currentNotice).schoolId;
                const baseHref = window.location.href.indexOf('www.weixiaojia.net') !== -1 || window.location.href.indexOf('localhost') !== -1 ? 'https://www.weixiaojia.net/mobile/#/' : 'https://m.www.weixiaojia.cn/mobile/#/';

                let isExpire = 0;
                if(this.formData.openTime && this.formData.closeTime) {
                    const currentDatetime = moment().format('YYYY-MM-DD HH:mm'),
                        openTime = moment(this.formData.openTime).format('YYYY-MM-DD HH:mm'),
                        closeTime = moment(this.formData.closeTime).format('YYYY-MM-DD HH:mm');
                    if(currentDatetime < openTime || currentDatetime > closeTime) {
                        isExpire = 1;
                    }
                }

                console.log(`${baseHref}primarySchoolSignup/ticketIndex?noticeId=${this.currentNotice}&schoolId=${schoolId}&isExpire=${isExpire}`)
                QRCode.toDataURL(`${baseHref}primarySchoolSignup/ticketIndex?noticeId=${this.currentNotice}&schoolId=${schoolId}&isExpire=${isExpire}`)
                    .then(url => {
                        this.qrcodeUrl = url;
                    })
                    .catch(err => {
                    });
            },
            copyLastYear() {
                copyBeforeWindowSetInfo({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message({
                                message: '复制成功',
                                type: 'success'
                            });
                            this.getNoticeWindowInfoFunc();
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
            },
            saveHandler() {
                this.$refs.formData.validate(isValid => {
                    if(isValid) {
                        if(this.windowSetting.length < 2) {
                            this.$message.error('至少设置2个窗口');
                        } else if (this.addressBookData.length === 0 || this.addressBookData.some(({userJson}) => userJson.length === 0)) {
                            this.$message.error('请设置审批人');
                        } else {
                            let valid = true;
                            const names = [];
                            this.windowSetting.forEach(item => {
                                if (item.windowNo === '') {
                                    this.$message.error('窗口名称不能为空');
                                    valid = false;
                                    return false;
                                } else if (names.indexOf(item.windowNo) !== -1) {
                                    this.$message.error('窗口名称不能重复');
                                    valid = false;
                                    return false;
                                } else {
                                    names.push(item.windowNo);
                                }
                            });

                            if (valid) {
                                const windiwSetJson = [];
                                this.windowSetting.forEach((windowItem, index) => {
                                    windiwSetJson.push({
                                        isFast: windowItem.isFast ? 1 : (windowItem.isDependent ? 3 : 2),
                                        windowNo: windowItem.windowNo,
                                        windowOrder: index + 1,
                                        examineJson: this.addressBookData[index].userJson,
                                        noticeId: this.currentNotice,
                                        id: windowItem.id || 0
                                    });
                                });
                                console.log(windiwSetJson)
                                saveNoticeWindowInfo({
                                    noticeId: this.currentNotice,
                                    closeTime: moment(this.formData.closeTime).format('YYYY-MM-DD HH:mm'),
                                    openTime: moment(this.formData.openTime).format('YYYY-MM-DD HH:mm'),
                                    remarkOne: this.formData.remarkOne,
                                    remarkTwo: this.formData.remarkTwo,
                                    windowNosJson: JSON.stringify(windiwSetJson)
                                })
                                    .then(res => res.data)
                                    .then(data => {
                                        if (data.result) {
                                            this.$message({
                                                message: '设置成功',
                                                type: 'success'
                                            });
                                            this.getNoticeWindowInfoFunc();
                                        } else {
                                            this.$message.error(data.msg);
                                        }
                                    })
                            }

                        }
                    }
                });

            },
            addWindow() {
                this.windowSetting.push({
                    windowNo: String.fromCharCode(65 + this.usedIndex),
                    isFast: false,
                    isDependent: false
                });
                this.addressBookData.push({
                    departJson: [],
                    groupJson: [],
                    userJson: []
                });
                this.usedIndex++;
            },
            deleteWindow(id, index) {
                if(!id) {
                    this.windowSetting.splice(index, 1);
                    this.addressBookData.splice(index, 1);
                } else {
                    deleteWindowNoById({
                        windowId: id
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getNoticeWindowInfoFunc();
                            } else {
                                this.$message.error(data.msg);

                            }
                        })
                }

            },
            fastWindowChange(index) {
                this.windowSetting.forEach((item, itemIndex) => {
                    if (itemIndex !== index) {
                        item.isFast = false;
                    } else {
                        item.isDependent = false;
                    }
                });
            },
            dependentWindowChange(index) {
                this.windowSetting.forEach((item, itemIndex) => {
                    if (itemIndex !== index) {
                        item.isDependent = false;
                    } else {
                        item.isFast = false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        background-color: #fff;
        z-index: 1000;
        padding: 20px 0 0 0;
    }

    .main-container {
        padding: 20px 0 0 0;
    }

    .window-item {
        font-size: 14px;
        border: 1px solid #999;
        padding: 10px 20px;
        width: 553px;
        margin-bottom: 20px;

        .address-book-container {
            width: 100%;
            margin-top: 10px;
        }

        & > * {
            @include middleIB;

        }

        .window-item__name {
            & > * {
                @include middleIB;
            }
        }

        .window-item__del-btn {
            margin-left: 40px;
            color: #f08080;

            .fa {
                cursor: pointer;
            }
        }
    }

    .default-page-container {
        width: 450px;
    }

    .require-hint {
        color: #ff0000;
        margin-right: 5px;
    }

    .header {
        font-size: 18px;
        width: 250px;
        white-space: nowrap;
        padding: 0 0 10px 0;

        .color-block {
            @include wh(12px, 12px);
            @include middleIB;
            background-color: #20a0ff;
            margin-right: 5px;
        }
    }

    .qrcode-container {
        width: 450px;
        text-align: center;
    }
    .qrcode-date {
        text-align: center;
    }
    .window-section {
        float: left;
    }

    .qrcode-section {
        margin-left: 50px;
        float: left;
    }

    .preview-dialog {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 2000;

        .preview-container {
            z-index: 2100;
            width: 375px;
            height: 667px;
            position: absolute;
            background: url(https://cdnfile-10043692.file.myqcloud.com/mobile/images/enroll_student/bg.jpg) no-repeat;
            background-size: cover;
            overflow-y: auto;
            padding-bottom: 20px;
            box-sizing: border-box;
            left: 50%;
            top: 50%;
            transform: translateY(-50%) translateX(-50%);
            .login-form {
                padding-top: 60px;
                color: #596171;
            }
            .first-login-hint {
                width:90%;
                font-size: 24px;
                text-align: center;
                color: #2397c8;
                display: flex;
                justify-content: center;
                align-items: center;
                margin:0 auto;
            }
            .first-login-hint .logo{
                width:46px;
                height:46px;
                display: block;
                background:url(https://cdnfile-10043692.file.myqcloud.com/mobile/images/enroll_student/logo.png) no-repeat;
                background-size:cover;
                margin-right:10px;
            }
            .input-item {
                margin: 10px auto;
                width: 70%;
                padding:0 26px;
                position: relative;
            }
            .phone-input {
                width: 100%;
                height: 40px;
                line-height: 34px;
                font-size: 20px;
                box-sizing: border-box;
                padding: 5px;
            }
            .button-container {
                width: 70%;
                margin: 100px auto 20px auto;
            }
            .ticket-header {
                /*color: #ff0000;*/
                width: 84%;
                text-align: center;
                position: absolute;
                top: 20%;
                font-size: 18px;
                left: 50%;
                transform: translateX(-50%);
            }
            .ticket-header__main {
                color: #1AAD19;
                font-size: 30px;
                margin-bottom: 5px;
            }
            .ticket-detail {
                position: absolute;
                text-align: center;
                width: 77%;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                font-size: 22px;
            }
            .ticket-detail__number {
                max-width: 100%;
                margin: 0 auto;
                word-break: break-all;
                line-height: 1.2em;
                font-size: 50px;
                color: #F08080;
            }
            .ticket-detail__children span {
                display: inline-block;
                vertical-align: middle;
                margin: 0 10px;
            }
            .ticket-detail__children {
                color: #000;
                margin: 10px 0 20px;
            }
            .small {
                font-size: 16px;
            }
            .example {
                margin: 0 auto;
            }
            .example-pic {
                width: 50%;
                margin: 0 auto;
            }
            .example img {
                width: 100%;
            }
            .hint2 {
                font-size: 16px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/setting/TicketWindowSetting.vue